(function(){
"use strict";
var clamp=function(v,a,b){return Math.max(a,Math.min(b,v))};
var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
function init(){
var root=document.getElementById("rs-home");
if(!root)return;
/* ================= story engine ================= */
var story=document.getElementById("story");
var slides=$$("#story .slide");
var bar=document.getElementById("storybar");
var taphint=document.getElementById("taphint");
var skipbtn=document.getElementById("skipbtn");
var reduced=matchMedia("(prefers-reduced-motion: reduce)").matches;
var segs=[];
if(story&&bar){
slides.forEach(function(){var seg=document.createElement("div");seg.className="seg";seg.appendChild(document.createElement("i"));bar.appendChild(seg)});
segs=$$("#storybar .seg");
}
var idx=-1,timer=null,ended=false,interacted=false,beatStart=0,MIN_DWELL=1000;
function setSeg(i,state,dur){
var seg=segs[i];if(!seg)return;
var fill=seg.querySelector("i");
seg.classList.remove("now","done");
fill.style.transition="none";fill.style.width="0%";
if(state==="done"){seg.classList.add("done")}
else if(state==="now"){seg.classList.add("now");void fill.offsetWidth;fill.style.transition="width "+dur+"ms linear";fill.style.width="100%"}
}
function show(i){
if(timer){clearTimeout(timer);timer=null}
i=clamp(i,0,slides.length-1);idx=i;beatStart=Date.now();
slides.forEach(function(s,j){
s.classList.toggle("active",j===i);
if(j===i){$$(".rv,.strikeword",s).forEach(function(el){el.style.transition="none";void el.offsetWidth;el.style.transition=""})}
});
segs.forEach(function(_,j){setSeg(j,j<i?"done":(j===i?"":"pending"))});
var dur=reduced?Math.min(+slides[i].getAttribute("data-dur"),3000):+slides[i].getAttribute("data-dur");
setSeg(i,"now",dur);
if(slides[i].id==="swirl")countUp();
timer=setTimeout(function(){if(i<slides.length-1)show(i+1);else endStory()},dur);
}
function endStory(instant){
if(ended)return;ended=true;
if(timer){clearTimeout(timer);timer=null}
if(!story){document.body.classList.remove("story-mode");return}
if(bar)bar.style.display="none";
if(taphint)taphint.style.display="none";
if(skipbtn)skipbtn.style.display="none";
if(instant){story.style.display="none";document.body.classList.remove("story-mode");return}
story.style.transition="opacity .8s ease";story.style.opacity="0";
setTimeout(function(){story.style.display="none";document.body.classList.remove("story-mode");scrollTo(0,0)},820);
}
function startStory(){
if(!story)return;
ended=false;
document.body.classList.add("story-mode");
story.style.display="";story.style.opacity="1";
if(bar)bar.style.display="flex";
if(skipbtn)skipbtn.style.display="";
if(taphint){taphint.style.display="";taphint.classList.remove("gone")}
scrollTo(0,0);show(0);
setTimeout(function(){if(taphint)taphint.classList.add("gone")},5200);
}
function canAdvance(){return Date.now()-beatStart>=MIN_DWELL}
function next(){if(!canAdvance())return;idx<slides.length-1?show(idx+1):endStory()}
function prev(){if(!canAdvance()||idx<=0)return;show(idx-1)}
if(story){
story.addEventListener("click",function(ev){
if(ended)return;
if(!interacted){interacted=true;if(taphint)taphint.classList.add("gone")}
ev.clientX<innerWidth/3?prev():next();
});
addEventListener("wheel",function(ev){
if(ended)return;
ev.preventDefault();
var now=Date.now();
if(Math.abs(ev.deltaY)<8||now-(startStory.lw||0)<520)return;
startStory.lw=now;
ev.deltaY>0?next():prev();
},{passive:false});
var touchY=null;
story.addEventListener("touchstart",function(ev){touchY=ev.touches[0].clientY},{passive:true});
story.addEventListener("touchend",function(ev){
if(ended||touchY===null)return;
var dy=touchY-ev.changedTouches[0].clientY;touchY=null;
if(dy>60)next();else if(dy<-60)prev();
},{passive:true});
addEventListener("keydown",function(ev){
if(ended)return;
if(ev.key==="ArrowRight"||ev.key===" "||ev.key==="ArrowDown"){ev.preventDefault();next()}
else if(ev.key==="ArrowLeft"||ev.key==="ArrowUp"){prev()}
else if(ev.key==="Escape"){endStory()}
});
if(skipbtn)skipbtn.addEventListener("click",function(){endStory()});
}
var replay=document.getElementById("replay");
if(replay)replay.addEventListener("click",function(ev){ev.preventDefault();startStory()});
var counted=false;
function countUp(){
if(counted)return;counted=true;
$$("#swirl [data-count]").forEach(function(el){
var target=+el.getAttribute("data-count"),start=null;
function tick(ts){if(!start)start=ts;var t=clamp((ts-start)/1000,0,1);el.textContent=Math.round((t<.5?2*t*t:-1+(4-2*t)*t)*target);if(t<1)requestAnimationFrame(tick)}
requestAnimationFrame(tick);
});
}
/* story autoplay: once (per session) | always | off — never in theme editor */
var mode=root.getAttribute("data-story-mode")||"off";
var seen=false;try{seen=sessionStorage.getItem("rs-story-seen")==="1"}catch(e){}
var design=typeof Shopify!=="undefined"&&Shopify.designMode;
if(story&&!design&&(mode==="always"||(mode==="once"&&!seen))){
try{sessionStorage.setItem("rs-story-seen","1")}catch(e){}
startStory();
}else{endStory(true)}
/* ---------- shop photo carousel: auto-fade + sync to flavor selection ---------- */
var car=document.getElementById("photo-carousel");
if(car){
var imgs=$$("img",car);
var noteEl=document.getElementById("imgnote-flavor");
var ci=0,holdUntil=0;
function carShow(i){
imgs[ci].classList.remove("show");
ci=i;
imgs[ci].classList.add("show");
var f=imgs[ci].getAttribute("data-flavor");
if(noteEl&&f)noteEl.textContent=f;
}
window.rsShowFlavor=function(name){
if(!name)return;
name=name.toLowerCase().trim();
for(var j=0;j<imgs.length;j++){
if(imgs[j].getAttribute("data-flavor")===name){
if(j!==ci)carShow(j);
holdUntil=new Date().getTime()+8000;
return;
}
}
};
if(imgs.length>1){
setInterval(function(){
if(new Date().getTime()<holdUntil)return;
carShow((ci+1)%imgs.length);
},3500);
}
}
/* ================= box builder → Shopify cart ================= */
var shop=document.getElementById("shop");
if(!shop)return;
var MIN=+shop.getAttribute("data-min")||8,MAX=+shop.getAttribute("data-max")||12,REC=+shop.getAttribute("data-rec")||10;
var flavors=$$(".flavor",shop).filter(function(f){return f.hasAttribute("data-variant-id")});
var totalEl=document.getElementById("total"),priceEl=document.getElementById("price"),hintEl=document.getElementById("hint"),fillEl=document.getElementById("fill"),subBtn=document.getElementById("subscribe"),errEl=document.getElementById("cart-error");
if(!subBtn)return;
var recTick=document.getElementById("rectick");
if(recTick&&MAX>MIN)recTick.style.left=(clamp((REC-MIN)/(MAX-MIN),0,1)*100)+"%";
var hasPlans=$$(".cadence button",shop).length>0;
var modeSub=document.getElementById("mode-sub"),modeOnce=document.getElementById("mode-once");
var cadWrap=shop.querySelector(".cadence");
var subscribeMode=hasPlans;
var money=function(cents){return (cents/100).toFixed(2)};
/* chip colors: known flavors, else palette */
var chipMap=[[/cocoa|chocolate|choc/i,"#5a3a26"],[/vanilla/i,"#e8dcc0"],[/orange|juli/i,"#e07b2f"],[/lemon|sorbet/i,"#e6d75a"],[/berry|strawb/i,"#c4455a"],[/mint/i,"#7fae8e"],[/coffee|mocha|espresso/i,"#4a3428"],[/peanut|butter/i,"#c98f45"]];
var palette=["#8a4a2f","#c2b280","#b0522d","#d9c9a8"];
flavors.forEach(function(f,i){
var chip=f.querySelector(".chip");if(!chip)return;
var name=f.getAttribute("data-flavor")||"";
var hit=chipMap.filter(function(p){return p[0].test(name)})[0];
chip.style.background=hit?hit[1]:palette[i%palette.length];
});
/* default quantities: spread REC across available flavors, extras to the first */
(function(){
var avail=flavors.filter(function(f){return !f.hasAttribute("data-soldout")});
if(!avail.length)return;
var base=Math.floor(REC/avail.length),rem=REC-base*avail.length;
avail.forEach(function(f,i){f.querySelector(".qty").textContent=base+(i===0?rem:0)});
})();
function planId(){if(!subscribeMode)return null;var b=shop.querySelector(".cadence button.sel");return b?b.getAttribute("data-plan-id"):null}
function unitPrice(f){
var pid=planId();
if(pid){
try{var pp=JSON.parse(f.getAttribute("data-plan-prices")||"{}");if(pp[pid]!=null)return +pp[pid]}catch(e){}
}
return +f.getAttribute("data-price")||0;
}
function boxTotal(){return flavors.reduce(function(s,f){return s+(+f.querySelector(".qty").textContent)},0)}
function boxPrice(){return flavors.reduce(function(s,f){return s+(+f.querySelector(".qty").textContent)*unitPrice(f)},0)}
function paint(){
var t=boxTotal(),p=boxPrice();
if(totalEl)totalEl.textContent=t;
if(priceEl)priceEl.textContent=money(p);
if(fillEl)fillEl.style.width=(clamp((t-MIN)/(MAX-MIN),0,1)*100)+"%";
flavors.forEach(function(f){
var q=+f.querySelector(".qty").textContent,so=f.hasAttribute("data-soldout");
f.classList.toggle("active",q>0);
f.querySelector(".plus").disabled=so||t>=MAX;
f.querySelector(".minus").disabled=so||q<=0||t<=MIN;
});
if(hintEl){
if(t<REC){hintEl.textContent=(REC-t)+" to the sweet spot · free shipping ✓"}
else if(t===REC){hintEl.textContent=REC+" — the sweet spot · free shipping ✓"}
else if(t===MAX){hintEl.textContent=MAX+" — the max · free shipping ✓"}
else{hintEl.textContent=t+" pucks · free shipping ✓"}
}
if(cadWrap)cadWrap.style.display=subscribeMode?"":"none";
subBtn.textContent=(subscribeMode?"Start My Subscription — $"+money(p)+"/box":"Add To Cart — $"+money(p)+" (one-time)");
}
flavors.forEach(function(f){
var fname=(f.querySelector(".nut")&&f.querySelector(".nut").getAttribute("data-flavor"))||(f.querySelector(".name")&&f.querySelector(".name").textContent)||"";
f.addEventListener("click",function(){if(window.rsShowFlavor)window.rsShowFlavor(fname)});
f.querySelector(".plus").addEventListener("click",function(){
if(boxTotal()<MAX){var q=f.querySelector(".qty");q.textContent=+q.textContent+1;paint()}
});
f.querySelector(".minus").addEventListener("click",function(){
var q=f.querySelector(".qty");
if(+q.textContent>0&&boxTotal()>MIN){q.textContent=+q.textContent-1;paint()}
});
});
$$(".cadence button",shop).forEach(function(b){
b.addEventListener("click",function(){
$$(".cadence button",shop).forEach(function(x){x.classList.remove("sel")});
b.classList.add("sel");paint();
});
});
if(modeSub&&modeOnce){
modeSub.addEventListener("click",function(){subscribeMode=true;modeSub.classList.add("sel");modeOnce.classList.remove("sel");paint()});
modeOnce.addEventListener("click",function(){subscribeMode=false;modeOnce.classList.add("sel");modeSub.classList.remove("sel");paint()});
}
paint();
/* checkout: add real line items to the Shopify cart, then straight to checkout */
subBtn.addEventListener("click",function(){
if(errEl){errEl.style.display="none"}
var items=flavors.map(function(f){
var q=+f.querySelector(".qty").textContent;
if(q<=0)return null;
var it={id:+f.getAttribute("data-variant-id"),quantity:q};
var pid=planId();if(pid)it.selling_plan=+pid;
return it;
}).filter(Boolean);
if(!items.length)return;
var label=subBtn.textContent;
subBtn.disabled=true;subBtn.textContent="Adding to cart…";
fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:items})})
.then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
.then(function(res){
if(!res.ok)throw new Error(res.j&&(res.j.description||res.j.message)||"Could not add to cart");
location.href="/checkout";
})
.catch(function(e){
subBtn.disabled=false;subBtn.textContent=label;
if(errEl){errEl.textContent=e.message;errEl.style.display="block"}
});
});
}
/* nutrition placard: keep shoppers on the ordering screen */
function nutInit(){
var nm=document.getElementById("nutmodal");
if(!nm)return;
var flavorEl=document.getElementById("nm-flavor");
var protEl=document.getElementById("nm-protein");
var ingEl=document.getElementById("nm-ing");
var data={};
try{var dEl=document.getElementById("nutdata");if(dEl)data=JSON.parse(dEl.textContent)}catch(err){}
function open(name){
if(flavorEl&&name)flavorEl.textContent=name;
var d=name?data[name.toLowerCase().trim()]:null;
if(window.rsShowFlavor)window.rsShowFlavor(name);
var calEl=document.getElementById("nm-cal");
if(calEl)calEl.textContent=(d&&d.cal)||"Finalizing";
if(protEl)protEl.textContent=(d&&d.protein)||"Finalizing";
var sugEl=document.getElementById("nm-sugar");
if(sugEl)sugEl.textContent=(d&&d.sugar)||"Finalizing";
var subEl=document.getElementById("nm-sub");
if(subEl)subEl.textContent=(d&&d.note)||"Sugar details will be listed on the final panel.";
if(ingEl)ingEl.textContent=(d&&d.ing)||"Real ingredients — full list being finalized.";
nm.hidden=false;document.body.classList.add("nm-open")}
function close(){nm.hidden=true;document.body.classList.remove("nm-open")}
Array.prototype.forEach.call(document.querySelectorAll(".flavor .nut"),function(b){
b.addEventListener("click",function(e){e.preventDefault();e.stopPropagation();open(b.getAttribute("data-flavor"))});
});
Array.prototype.forEach.call(nm.querySelectorAll("[data-nm-close]"),function(c){c.addEventListener("click",close)});
document.addEventListener("keydown",function(e){if(e.key==="Escape"&&!nm.hidden)close()});
}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",init);document.addEventListener("DOMContentLoaded",nutInit)}else{init();nutInit()}
})();
